import React, { useEffect, useState } from 'react';

import { MedicineBoxOutlined, TeamOutlined } from '@ant-design/icons';
import { Spin, Tabs } from 'antd';

import EditButton from '../../../components/buttons/edit';
import ConfigurationForm from '../../../components/configuracaoarquivos/form';
import {
  InlineContainer,
  VerticalContainer,
} from '../../../components/styled';
import ViewContainer from '../../../components/view_container';
import { getConfig, updateConfig } from '../../../services/configuracaoarquivos';

const { TabPane } = Tabs;

export default function ViewConfig({ computedMatch }) {
  const [error, setError] = useState();
  const [config, setConfig] = useState();
  const [viewMode, setViewMode] = useState(true);
  const { params } = computedMatch;

  const [loading, setLoading] = useState(false);
  const onFinish = async (values) => {
    try {
      setLoading(true);
      await updateConfig(config, values);
    } catch (err) {
      setError(err.error);
    } finally {
      setLoading(false);
    }
  };

  const handleTipo = async () => {
    const data = await getConfig(params.id);
    setConfig(data);
  };
  useEffect(() => {
    handleTipo();
  }, []);

  return (
    <Tabs defaultActiveKey="1" style={{ width: '100%' }}>
      <TabPane
        tab={(
          <span>
            <MedicineBoxOutlined />
            Detalhes
          </span>
        )}
        key="1"
      >
        <VerticalContainer>
          <InlineContainer>
            <div />
            <EditButton viewMode={viewMode} setViewMode={setViewMode} />
          </InlineContainer>
          {config ? (
            <ViewContainer item={config} marginLeft="0">
              <ConfigurationForm
                initialValues={{ ...config }}
                onFinish={onFinish}
                error={error}
                setError={setError}
                loading={loading}
                viewMode={viewMode}
              />
            </ViewContainer>
          ) : (
            <Spin />
          )}
        </VerticalContainer>
      </TabPane>
    </Tabs>
  );
}